<style lang="less">
@import "../../../styles/common.less";
</style>
<template>
<div class="evidenceInfoBox">
  <div class="topNav">
      <img class="img" src="../../../viewsGangAn/assets/index.png" alt="">
      <div class="r">></div>
      <div class="text" @click="onUrl('/memberInfo')">个人中心</div>
      <div class="r">></div>
      <div class="text" @click="onUrl('/evidenceAndTort')">网页取证</div>
      <div class="r">></div>
      <div class="text active">取证详情</div>
  </div>
  <div class="evidenceInfo">
    <div class="evidenceInfo-top" style="min-height:727px">
      <div class="evidenceInfo-top-title">
        <div class="title">取证详情</div>
      </div>
      <ul class="evidenceInfo-ul">
        <li>
          <span style="width:70px">取证网址：</span>
          <span class="spanRight">{{list.url?list.url:'-'}}</span>
        </li>
         <li>
          <span style="width:70px">服务器IP：</span>
          <span class="spanRight">{{list.dnsServerIp?list.dnsServerIp:'-'}}</span>
        </li>
         <li style="margin-bottom:20px">
          <span style="width:70px">取证时间：</span>
          <span class="spanRight">{{list.createDate?list.createDate:'-'}}</span>
        </li>
        <li class="img-box-li" :style="{ height: heightLi}" v-if="list.screenshotUrl">
          <img :src="list.screenshotUrl+'?x-image-process=image/resize,m_fixed,w_1262'" class="img-style" alt='版权登记'/>
          <div class="img-box-mask">
            <button class="img-box-more" @click="showMoreImg">{{btnConten}}</button>
          </div>
        </li>
      </ul>
    </div>
    <div class="evidenceInfo-top" style="min-height:357px" v-if="status=='证书已生成'"> 
      <div class="evidenceInfo-top-title">取证证书</div>
      <div class="evidence-content">
          <div class="evidence-bottom">
            <div style="width:166px;margin-right:20px"><img src="@/assets/evidence-img.png" alt='版权登记'/></div>
            <div class="evidence-bottom-right" >
              <p class="p-one">{{list.name?list.name+'-':''}}取证证书</p>
              <ul class="evidence-bottom-ul">
                <li>
                  <span style="width:70px">证书状态：</span>
                  <span>已认证</span>
                </li>
                 <li>
                  <span style="width:70px">证书编号：</span>
                  <span>{{list.evidenceOrderExtends.evidenceArchiveCertNumber}}</span>
                </li>
                 <li>
                  <span style="width:70px">核验单位：</span>
                  <span>中国科学院国家授时中心、北京天威诚信电子商务服务有限公司、版权区块链联盟</span>
                </li>
                 <li>
                  <span style="width:70px">认证日期：</span>
                  <span>{{list.createDate?list.createDate.split(' ')[0]:''}}</span>
                </li>
              </ul>
              <div>
                <!-- <button class="btn-76" @click="openVerify">证书核验</button> -->
                <a @click="downBook(list.evidenceOrderExtends.certUrl)" target="_blank" style="display:inline-block;color:#4e4e4e;margin:0px 15px 0 0;text-align:center" class="btn-76" >下载证书</a>
                <a :href="list.packageUrl" class="btn-76" style="display:inline-block;color:#4e4e4e;width:126px;text-align:center;margin-right:15px">下载取证数据包</a>
                <!-- <button class="btn-76" v-if="list.evidenceOrder.status=='证书已生成'" @click="downBcBook(list.orderSeqNo)" style="width:100px">下载BC文件
                </button> -->
              </div>
            </div>
          </div>
          <div class="evidence-bottom-tsc">
              <img src="@/assets/tsc_img.png" alt='版权登记'/>
              <div class="evidence-bottom-tsc-content">
                  <p class="p-one">{{list.name?list.name+'-':''}}可信时间凭证认证证书 </p>
                  <ul class="evidence-bottom-tsc-content-ul">
                      <li>
                          <span>签发单位：</span>
                      </li>
                      <li>
                          <span>
                              中国科学院国家授时中心<br/>
                              西安可信时间认证服务有限公司
                          </span>
                      </li>
                  </ul>
                  <div>
                      <button class="btn-76" v-if="kexinshijianUrl" @click="openTscVerify"> 查看证书</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <!-- 核验码 -->
    <verifycode @fatherModal="fatherModal" v-show="showModal" ref="childModal" :flag='flag' :orderSeqNo='orderSeqNo'></verifycode>
  </div>
</div>
</template>

<script>
import {bqjUrl} from "@/config/config"
import verifycode from '../verification/verifyCode';
export default {
  metaInfo: {
      title: '取证详情|国家版权创新发展基地',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,国家版权创新发展基地,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '取证详情,国家版权创新发展基地公共服务平台,人人都是创作者，人人都是版权人。国家版权创新发展基地公共服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "evidenceInfo",
  components:{
    verifycode
  },
  data(){
    return{
      list:"",
      status:"",
      showModal:!1,
      flag:'1',
      orderSeqNo:"",
      heightLi:'512px',
      btnConten:'查看完整图片',
      showAllImg:true,
      bqjUrlTh: bqjUrl,
      kexinshijianUrl: ''
    }
  },
  methods: {
    // 查看和下证
    downBook(url){
      if (url) {
        url = url.replace('https://file.bqj.cn','http://file.qh-copyright.cn')
        window.open( url, '_blank');
      } else {
        toast('暂无证书')
      }
    },
    onUrl(url) {
        this.$router.push(url)
    },
    //下载Bc
    downBcBook(orderSeqNo) {
       // /bqjvip/blockChain/tianPing/downloadBc?subBizType=0201&orderSeqNo=YZ202106011641340585442

        let subBizType = '0102'
        window.open(this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?subBizType=" + subBizType + "&orderSeqNo=" + orderSeqNo, '_self');
    },
     getEvidenceWebpage(){
      this.getRequest('/evidenceWebpage/get/'+this.$route.query.id).then(res=>{
        if(res.code==200){
         this.list=res.result;
         this.status=res.result.evidenceOrder.status;
         this.orderSeqNo = res.result.orderSeqNo
         this.tscCertBysn(this.orderSeqNo)
        }
      })
    },
    tscCertBysn(orderSeqNo) {
        let subBizType = '0301'

        this.getRequest(`/tsc/downloadTscCert/${subBizType}/${orderSeqNo}`).then(res => {
            
            if (res.code == 200) {
                this.kexinshijianUrl = res.result
            }

        })
    },
    fatherModal() {
        let _this = this;
        _this.showModal = !1;
    },
    openVerify(){
      // let _this = this;
      // _this.showModal = !0;
      let routeUrl = this.$router.resolve({
        path: "/index/creation_verification",
        name:'creationVerification',
        params: {type:this.flag,id:this.orderSeqNo}
      });
      window.open(routeUrl.href, '_blank');
    },
    showMoreImg(){
      this.showAllImg=!this.showAllImg;
      if(this.showAllImg){
        this.btnConten="查看完整图片";
        this.heightLi='512px';
      }else{
        this.btnConten="收起图片";
        this.heightLi='auto';
      }
      
    },
    openTscVerify() {
      if (this.kexinshijianUrl) {
        var url = this.kexinshijianUrl;
        url = url.replace('https://file.bqj.cn','http://file.qh-copyright.cn')
        window.open(url, '_blank');
      } else {
          toast('暂无证书')
      }
    }
  },
  created() {
    this.getEvidenceWebpage()
  },
};
</script>
<style scoped lang="less">
.img-box-li{
  position:relative;
  overflow: hidden;
  display: block!important;
  .img-style{
    max-width: 100%;
    height: auto;
  }
  .img-box-mask{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
    background-image: linear-gradient(0deg,#fff,hsla(0,0%,100%,0));
    text-align: center;
    .img-box-more{
      outline: none;
      width: 120px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #666;
      text-align: center;
      background: transparent;
      border-radius: 40px;
      margin:70px auto 0;
      border: 1px solid #dcdcdc;
      cursor: pointer; 
    }
  }
}
.evidenceInfoBox{
  background: #F4F8FC;
  .evidenceInfo{
    margin: 0 auto;
  }
  .evidenceInfo-top-title{
      width: 1200px;
      text-indent: 0;
      padding: 0 30px;
      display: flex;
      align-items: center;
      .title{
        font-size: 20px;
        font-weight: 700;
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;
        font-family: 'AlibabaPuHuiTi';
        line-height: 1.3;
        &::before{
            content: '';
            position: absolute;
            width: 36px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 3px;
            z-index: -1;
        }
      }
  }
  .topNav{
        display: flex;
        align-items: center;
        width: 1200px;
        margin: auto;
        padding: 18px 0;
        font-size: 14px;
        color:#999999;
        .img{
            width: 16px;
            height: 16px;
        }
        .r{
            margin: 0 10px;
        }
        .active{
            color: #2196F3;
        }
        .text{
            cursor: pointer;
        }
    }
}
.btn-76{
    border: 1px solid #2196F3 !important;
    color: #2196F3 !important;
    &:hover{
        background: none !important;
        border: 1px solid #2196F3 !important;
    }
}
</style>
